<template>
  <div class="home">
  <van-card
  price="99"
  desc="xx老师公开课"
  title="xxx课程"
  thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
>
  <template #tags>
    <van-tag color="#f2826a" style="margin-left: 5px">公开课</van-tag>
    <van-tag color="#f2826a" style="margin-left: 5px">必修</van-tag>
  </template>
  <template #footer>
    <van-button round type="info" size="mini" @click="toKeCheng">购买</van-button>
  </template>
</van-card>
  </div>
</template>

<script>

  export default {
    methods: {
        toKeCheng:function(){
         var that = this;
         var userId = sessionStorage.getItem('userId');
         var openid = sessionStorage.getItem('openid');
         var status = sessionStorage.getItem('status');
         console.log("openid:",openid)
         console.log("status:",status)
         alert(status);
         if(status == '0'){
           alert("未支付")
           this.$axios.get(
              "http://ysj.fxiang.cn/wxPay/getOpenId/",//根据openid获取用户信息
              {params:{
                openid:openid,
                }}
            ).then(function(resp){
                  console.log("hahhahahahhahhahahha:"+resp)
                  console.log("qqqqqqqq:"+resp.data.orderNo)
                  var orderNo = resp.data.orderNo
                  sessionStorage.setItem('orderNo',orderNo)
                  function onBridgeReady(){
                    console.log("sssssss:"+resp.data)
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                          "appId":resp.data.appId,     //公众号名称，由商户传入     
                          "timeStamp":resp.data.timeStamp,         //时间戳，自1970年以来的秒数     
                          "nonceStr":resp.data.nonceStr, //随机串     
                          "package":resp.data.package,     
                          "signType":resp.data.signType,         //微信签名方式：     
                          "paySign":resp.data.paySign //微信签名 
                        },
                        function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                              that.$axios.get(
                              "http://ysj.fxiang.cn/wxPay/getOrderNo/",
                              {params:{
                                  orderNo:orderNo,
                                  openid:openid,
                                }}
                              ).then(function(resp){
                                sessionStorage.setItem('status', "1");  
                                console.log("声明结果1111:"+resp)
                            },function(err){
                              console.log("失败1111")
                              this.$router.push({ path:'/ysj/course'  })
                            })
                        } 
                    }); 
                  }
                  if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                  }else{
                    onBridgeReady();
                  }
               
                 
                },function(err){
                  console.log("失败")
                })
         } else {
           alert("已支付")
           console.log("userId:"+userId)
           this.$router.push({ path:'/ysj/courseInfo'  })
         }
      },
    }
   

}
</script>
